export default __webpack_public_path__ + "static/media/laundry1-beforeA-2048w.952ed5b2.avif";